import {
  calculateAddedOptionGroups,
  hasFulfilledMaxMinSelectionForRequiredOptionGroups,
} from '../utils/customizations';
import type { MenuItemVariantDto, OptionGroupDto } from '../../generated-api';
import type { CartAdditionOption } from '../../types/cart';

type UseCustomisationsFn = (
  item: MenuItemVariantDto,
  options: CartAdditionOption[]
) => {
  requiredOptionGroups: OptionGroupDto[];
  addedRequiredOptionGroups: OptionGroupDto[];
  hasAddedAllRequiredOptionGroups: boolean;
};

export const useCustomisations: UseCustomisationsFn = (item, options) => {
  const requiredOptionGroups = item.optionGroups.filter((optionGroup) => optionGroup.required);

  const addedRequiredOptionGroups = calculateAddedOptionGroups(options, requiredOptionGroups);

  const hasAddedAllRequiredOptionGroups = hasFulfilledMaxMinSelectionForRequiredOptionGroups(
    options,
    requiredOptionGroups
  );

  return {
    addedRequiredOptionGroups,
    hasAddedAllRequiredOptionGroups,
    requiredOptionGroups,
  };
};
